import { FormLabel } from "@/components/ui/form";
import { useTranslation } from "react-i18next";
import DependentQuestions from "../../DependentQuestions";
import Field from "@/components/Field";
import VisualizationTypeSelect from "../../VisualizationTypeSelect";
import VariantsList from "./VariantsList";
import Fieldset from "@/components/Fieldset";
import { isRequired } from "@/lib/form";
import { cfg } from "@/schemas/question/cfg";

interface QuestionRadioProps {
  index: number;
}

const QuestionRadio = ({ index }: QuestionRadioProps) => {
  const { t } = useTranslation();

  const translationKeys = {
    variant: "surveyEditor.radioType.variant",
    addVariant: "surveyEditor.radioType.addVariant",
    noVariantsFound: "surveyEditor.radioType.noVariantsFound",
  };

  return (
    <Fieldset>
      <Field
        label={t("surveyEditor.visualization")}
        name={`questions.${index}.cfg.visualization`}
        required={isRequired(cfg.shape.visualization)}
        render={({ field }) => <VisualizationTypeSelect {...field} />}
      />
      <FormLabel>{t("surveyEditor.radioType.variants")}</FormLabel>
      <VariantsList
        name={`questions.${index}.cfg.variants`}
        translationKeys={translationKeys}
      />
      <DependentQuestions index={index} />
    </Fieldset>
  );
};

export default QuestionRadio;
